/**
 * @file 求人票の候補追加
 */
'use strict'

/**
 * @classname JobInformationTableCell
 */
export default class JobInformationTableCell {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('JobInformationTableCell.constructor')
		this._$e = $e
		this._$tr = this._$e.closest('.tr')
		this._$table = this._$e.closest('.table')
		this._$checkbox = this._$tr.find('.input-checkbox-input')
		this._$id = this._$tr.find('.id-column')
		this._$formAddCandidate = $('#form-add-candidate')
		this._$formDeleteCandidate = $('#form-delete-candidate')
		this.inputNameAttr = this.isCandidateTable() ? this._$table.attr('data-remove-candidate-name') : this._$table.attr('data-add-candidate-name')
		this._$e.on('click', () => (this.isCandidateTable() ? this.onClickCandidate() : this.onClickList()))
		this._$checkbox.on('click', () => this.onChackboxChange())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof JobInformationTableCell
	 * @return {undefined}
	 */
	onClickList() {
		console.log(`JobInformationTableCell.onClick`)
		if (this.isChecked()) {
			console.log(`チェックされています：追加`)
			this.removeCorrespondenceInput(this._$formAddCandidate)
			this._$tr.removeClass('bg-pink')
			this._$checkbox.prop('checked', false)
		} else {
			console.log(`チェックされてないよ：追加`)
			this._$tr.addClass('bg-pink')
			this._$checkbox.prop('checked', true)
			this._$formAddCandidate.append(`<input type="hidden" name="${this.inputNameAttr}" value="${this._$id.text()}">`)
		}
	}
	/**
	 * クリックのコールバック
	 *
	 * @memberof JobInformationTableCell
	 * @return {undefined}
	 */
	onClickCandidate() {
		console.log(`JobInformationTableCell.onClickCandidate`)
		if (this.isChecked()) {
			console.log(`チェックされています：削除`)
			this.removeCorrespondenceInput(this._$formDeleteCandidate)
			this._$tr.removeClass('bg-gray')
			this._$checkbox.prop('checked', false)
		} else {
			console.log(`チェックされてないよ：削除`)
			this._$tr.addClass('bg-gray')
			this._$checkbox.prop('checked', true)
			this._$formDeleteCandidate.append(`<input type="hidden" name="${this.inputNameAttr}" value="${this._$id.text()}">`)
		}
	}
	/**
	 * 追加したinput要素を見つけて削除する
	 *
	 * @memberof JobInformationTableCell
	 * @return {undefined}
	 */
	removeCorrespondenceInput($form) {
		console.log(`JobInformationTableCell.findCorrespondenceInput`)
		const id = this._$id.text()
		$form.find('input').each((idx, el) => {
			const $el = $(el)
			if ($el.attr('value') == id) {
				$el.remove()
			}
		})
	}

	/**
	 * チェック状態かどうか確認する
	 *
	 * @memberof JobInformationTableCell
	 * @return {undefined}
	 */
	isChecked() {
		console.log(`JobInformationTableCell.isChecked`)
		return this._$checkbox.prop('checked')
	}

	/**
	 * 候補テーブルかどうか確認する
	 *
	 * @memberof JobInformationTableCell
	 * @return {undefined}
	 */
	isCandidateTable() {
		console.log(`JobInformationTableCell.isCandidateTable`)
		return this._$table.hasClass('table-job-information-candidate')
	}

	/**
	* チェックボックスにチェックされたら選択状態にする
	*
	* @memberof JobInformationTableCell
	* @return {undefined}
	*/
	onChackboxChange(){
		console.log(`JobInformationTableCell.onChackboxChange`)
		this._$e.click(this.isCandidateTable() ? this.onClickCandidate() : this.onClickList())
	}
}
